module.exports = __webpack_public_path__ + "static/media/Melissa1.811703da.jpg";